document.addEventListener('alpine:init', () => {
	Alpine.data('sc_collapse', (cfg) => ({
		id: cfg.id,
		_isExpanded: cfg.expanded || false,
		_hasAccordion: false,
		lockedClosed: cfg.lockedClosed || false,

		init() {
			if (!this.lockedClosed && typeof this.register === 'function') {
				this._hasAccordion = true;
				this.register(this.id, this._isExpanded);
			}
			
			Alpine.effect(() => {
				if (this._hasAccordion && typeof this.isOpen === 'function') {
					this._isExpanded = this.isOpen(this.id);
				}
			});
		},
		
		toggleCollapse() {
			if (this.lockedClosed) return;
			if (this._hasAccordion && typeof this.toggle === 'function') {
				this.toggle(this.id);
			} else {
				this._isExpanded = !this._isExpanded;
			}
		}
	}));
});
